<!-- @format -->

<sis-plan-structure-education
  [education]="education"
  [planValidationResult]="planValidationResult"
  [planStateObject]="planStateObject"
  [planData]="planData">
</sis-plan-structure-education>
